var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"scrollContainer",class:_vm.parentSuiteList && _vm.parentSuiteList.length > 2
    ? _vm.$store.state.appConfig.layout.type == 'full' ? 'right-side right-full-screen' : 'right-side right-fix-height'
    : 'right-side',on:{"scroll":_vm.updateScrollbarValue}},_vm._l((_vm.parentSuiteList),function(item){return _c('SuiteTestCase',{key:item.id,attrs:{"id":item.id,"item":item}})}),1),(
    _vm.$store.state.app.testSuite.parent_suite_id ||
    _vm.$store.state.app.testSuite.id
  )?_c('addtestcreate',{ref:"addSuite",attrs:{"id":"createSuite"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }